import { styled } from "../../../styled-components";

export const ElementTrackingPortalStyle = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;

    & > .etps-ContentContainer {
        position: absolute;

        pointer-events: none;
    }

    & > .etps-ContentContainer > * {
        pointer-events: auto;
    }
`;
